/**
 * TESTES DISC e QA — os textos de tela, LITERAIS do conteúdo aprovado (`textos.json`, gerado do conteúdo do servidor;
 * um teste confere que é idêntico). Nenhum texto desta feature nasce aqui: regra 10 do pedido.
 */
import conteudo from './textos.json';
import type { TipoTeste } from './tipos';

export const TEXTOS = conteudo.textos_interface;
export const ABERTURA = { disc: conteudo.disc.abertura, qa: conteudo.qa.abertura };
export const INSTRUCAO = { disc: conteudo.disc.instrucao, qa: conteudo.qa.instrucao };
/** Textos que chegaram depois do conteúdo de 02/10 (`server/lib/testes/textos-extra.json`, pedido FEEDBACK-CARREIRA). */
export const TEXTOS_EXTRA = conteudo.extra;

/** A1 (05/10): os textos do RESULTADO para quem olha — o funcionário ("Seu perfil principal") ou quem olha a ficha de
 * outra pessoa (terceira pessoa). A MESMA regra do servidor (`server/lib/testes/textos-extra.ts`). */
export function textosDoResultado(paraGestor: boolean): typeof TEXTOS.link_publico {
  return paraGestor ? { ...TEXTOS.link_publico, ...TEXTOS_EXTRA.gestor } : TEXTOS.link_publico;
}

/** A1: quem vê o resultado de OUTRA pessoa lê "Resultado … de {primeiro_nome}", nunca "Seu resultado". */
export function tituloDoResultadoParaGestor(tipo: TipoTeste, primeiroNome: string): string {
  const modelo = tipo === 'disc' ? TEXTOS_EXTRA.titulo_resultado_disc_gestor : TEXTOS_EXTRA.titulo_resultado_qa_gestor;
  return preencher(modelo, { primeiro_nome: primeiroNome });
}

/** Troca `{chave}` pelos valores (a mesma regra do servidor: chave sem valor fica como está). */
export function preencher(texto: string, valores: Record<string, string | number>): string {
  return texto.replace(/\{([a-z_0-9]+)\}/gi, (m, k: string) => (k in valores ? String(valores[k]) : m));
}

/** {teste} e {teste_minusculo} — `textos_interface._nota`. */
export function nomeDoTeste(tipo: TipoTeste): { teste: string; testeMinusculo: string } {
  const sigla = tipo === 'disc' ? 'DISC' : 'QA';
  return { teste: `Teste ${sigla}`, testeMinusculo: `teste ${sigla}` };
}

export const TOTAL: Record<TipoTeste, number> = { disc: 40, qa: 20 };
